import React from "react";
import EditorShell from "../EditorShell";
import { TextareaField } from "../fields";
import { closingTaglineSchema, SECTION_DEFAULTS } from "../schemas";

const ClosingTaglineEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="closing_tagline"
    schema={closingTaglineSchema}
    defaults={SECTION_DEFAULTS.closing_tagline}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <TextareaField
        form={form}
        path="text"
        label="Closing tagline"
        required
        rows={3}
        hint="Wrap a phrase in *asterisks* to highlight it with the gradient italic style."
      />
    )}
  </EditorShell>
);

export default ClosingTaglineEditor;
